import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest.js';

export const GetClustersNamesRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Shutdown3g/GetClustersNames`,
	params: { userId }
});

export const GenerateShutdownReportRequest = (userId, clusterName, shutdownDate, type) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Shutdown3g/GenerateShutdownReport`,
	params: { userId, clusterName, shutdownDate, type }
});

export const GenerateShutdownReportV2Request = (userId, clusterName, shutdownDate, postDate) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Shutdown3g/GenerateShutdownReportV2Request`,
	params: { userId, clusterName, shutdownDate, postDate }
});
